<script lang="ts" module>
  const regex = /({\S+})/;
  const getSections = <T,>(translation: string, values: Record<string, T>): (T | string)[] =>
    translation.split(regex).map((section) => {
      if (!regex.test(section)) {
        return section;
      }

      const key = section.slice(1, -1);
      return values[key] ?? '';
    });

  export const interpolate = (translation: string, values: Record<string, string>): string =>
    getSections(translation, values).join('');
</script>

<script lang="ts">
  import type { Snippet } from 'svelte';

  type Props = {
    translation: string;
    snippets: Record<string, Snippet>;
  };

  const { translation, snippets }: Props = $props();
  const sections = $derived(getSections(translation, snippets));
</script>

{#each sections as section}
  {#if typeof section === 'string'}
    {section}
  {:else}
    {@render section()}
  {/if}
{/each}
